import { useState } from "react";
import {
  Alert,
  Button,
  CircularProgress,
  DialogActions,
  DialogContent,
} from "@mui/material";
import ResponsiveDialog from "../UI/ResponsiveDialog";
import { useMutation } from "@apollo/client";
import { ADD_TEAM_TO_SEASON } from "../../GraphQL/Season";
import {
  GET_TEAMS_BY_SEASON_ID,
  GET_TEAMS_NOT_BY_SEASON_ID,
} from "../../GraphQL/Teams";
import useNotification from "../../hooks/useNotification.js";
import TeamSelect from "./TeamSelect";

const AddTeamToSeasonDialog = (props) => {
  const [team, setTeam] = useState(null);
  const { notifySuccess } = useNotification();

  const [addTeamToSeason, { loading, error }] = useMutation(
    ADD_TEAM_TO_SEASON,
    {
      variables: {
        seasonId: props.seasonId,
        teamId: team,
      },
      refetchQueries: [GET_TEAMS_BY_SEASON_ID, GET_TEAMS_NOT_BY_SEASON_ID],
      onCompleted: () => { notifySuccess("Team added to season."); props.setOpen(false); },
    }
  );

  return (
    <div>
      <ResponsiveDialog
        open={props.open}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            addTeamToSeason();
          } else if (e.key === "Escape") {
            props.setOpen(false);
          }
        }}
        title="Team"
        onClose={() => props.setOpen(false)}
      >
        <DialogContent>
          <TeamSelect
            seasonId={props.seasonId}
            team={team}
            setTeam={setTeam}
            teams={props.teams}
          />
        </DialogContent>
        {error && (
          <Alert severity="error" sx={{ mx: 2, mb: 1 }}>
            {error.message}
          </Alert>
        )}
        <DialogActions>
          <Button
            data-testid="saveAddTeamToSeasonDialogButton"
            variant="contained"
            onClick={() => addTeamToSeason()}
            disabled={loading}
          >
            {loading ? (
              <CircularProgress size={20} sx={{ color: "inherit" }} />
            ) : (
              "Add"
            )}
          </Button>
          <Button
            data-testid="closeAddTeamToSeasonDialogButton"
            onClick={() => props.setOpen(false)}
          >
            Cancel
          </Button>
        </DialogActions>
      </ResponsiveDialog>
    </div>
  );
};

export default AddTeamToSeasonDialog;
